import { render } from "./PendingOrder.vue?vue&type=template&id=1ac39ced&scoped=true"
import script from "./PendingOrder.vue?vue&type=script&lang=js"
export * from "./PendingOrder.vue?vue&type=script&lang=js"

import "./PendingOrder.vue?vue&type=style&index=0&id=1ac39ced&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ac39ced"]])

export default __exports__